<template>
  <div class="clearfix">
    <div id="logo">
      <router-link to="/" v-if="subdomain === '#pfx'">
        <img :src="logoUrl" />
      </router-link>
      <a :href="pfxLandingPageUrl" v-else>
        <img :src="logoUrl" />
      </a>
    </div>
    <nav :class="dark ? 'dark' : ''">

      <ul v-if="$store.state.tenant.subdomain === '#pfx'">
        <li><router-link to="/about/for-brokers">Brokers</router-link></li>
        <li><router-link to="/about/for-buyers">Buy</router-link></li>
        <li><router-link to="/about/for-sellers">Sell</router-link></li>
        <li class="wide-show"><router-link to="/faq">Help</router-link></li>
        <li class="wide-show"><router-link to="/about">About</router-link></li>
        <li v-if="authenticatedUser === false"><a @click="$store.commit('openLoginDialog')">Login</a></li>
        <li class="blue-pill"><a @click="$store.commit('openGetStartedDialog')">Get Started</a></li>
        <li class="wide-hide" v-if="authenticatedUser === false" @click.stop="$store.state.headerMenuVisible = !$store.state.headerMenuVisible">
          <v-icon :dark="dark">expand_more</v-icon>
        </li>
        <li v-if="authenticatedUser === true" @click.stop="$store.state.headerMenuVisible = !$store.state.headerMenuVisible">
          <img v-if="photoUrl" :src="photoUrl" class="user-avatar" />
          <v-icon medium :dark="true" v-else>account_circle</v-icon>
          {{ profileLinkLabel }} <v-icon :dark="true">expand_more</v-icon>
        </li>
        <li v-if="authenticatedUser === null"><InlineSpinner /></li>

        <div v-show="$store.state.headerMenuVisible" class="popup-menu" @click.stop="$store.state.headerMenuVisible = false">
          <ul>
            <li class="wide-hide"><router-link to="/faq">Support</router-link></li>
            <li class="wide-hide"><router-link to="/listings">Browse Auctions</router-link></li>
            <template v-if="authenticatedUser === true">
              <li><router-link to="/dashboard">Dashboard</router-link></li>
              <li><router-link to="/profile">My Profile</router-link></li>
              <li v-if="tenantRole === tenantRoles.ADMIN.value"><router-link to="/company/profile">Company Profile</router-link></li>
              <li v-if="isPfxAdmin"><router-link to="/pfxadmin/tenants">PFX Platform Admin</router-link></li>
              <li @click="logout">Logout</li>
            </template>
          </ul>
        </div>
      </ul>

      <ul v-else>
        <li class="wide-show"><router-link to="/">Home</router-link></li>
        <li class="wide-show" @click="forcedRefresh('listings')">Browse Auctions</li>
        <li v-if="authenticatedUser === false"><a @click="$store.commit('openLoginDialog')">Login</a></li>
        <li v-if="authenticatedUser === false"><a @click="$store.commit('openSignUpDialog')">Sign Up</a></li>
        <li class="wide-show" v-if="authenticatedUser === true"><router-link to="/dashboard">Dashboard</router-link></li>
        <li class="wide-hide" v-if="authenticatedUser === false" @click.stop="$store.state.headerMenuVisible = !$store.state.headerMenuVisible">
          <v-icon :dark="dark">expand_more</v-icon>
        </li>
        <li v-if="authenticatedUser === true" @click.stop="$store.state.headerMenuVisible = !$store.state.headerMenuVisible">
          <img v-if="photoUrl" :src="photoUrl" class="user-avatar" />
          <v-icon medium :dark="true" v-else>account_circle</v-icon>
          {{ profileLinkLabel }} <v-icon :dark="true">expand_more</v-icon>
        </li>
        <li v-if="authenticatedUser === null"><InlineSpinner /></li>

        <div v-show="$store.state.headerMenuVisible" class="popup-menu" @click.stop="$store.state.headerMenuVisible = false">
          <ul>
            <li class="wide-hide"><router-link to="/">Home</router-link></li>
            <li class="wide-hide"><router-link to="/listings">Browse Auctions</router-link></li>
            <template v-if="authenticatedUser === true">
              <li class="wide-hide"><router-link to="/dashboard">Dashboard</router-link></li>
              <li><router-link to="/profile">My Profile</router-link></li>
              <li v-if="tenantRole === tenantRoles.ADMIN.value"><router-link to="/company/profile">Company Profile</router-link></li>
              <li v-if="isPfxAdmin"><router-link to="/pfxadmin/tenants">PFX Platform Admin</router-link></li>
              <li @click="logout">Logout</li>
            </template>
          </ul>
        </div>
      </ul>

    </nav>
  </div>
</template>

<script>
  import InlineSpinner from './InlineSpinner.vue'
  import { tenantRoles } from '../../utils/PfxUtils.js'
  import { mapGetters } from 'vuex'

  export default {
    name: 'MainHeaderContent',
    components: {
      InlineSpinner
    },
    props: {
      dark: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        tenantRoles,
        menuVisible: false,
        pfxLandingPageUrl: process.env.config.frontend.pfxLandingPage,
        subdomain: this.$store.state.tenant.subdomain
      }
    },
    computed: {
      ...mapGetters([
        'authenticatedUser',
        'tenantRole',
        'isPfxAdmin',
        'photoUrl',
        'fullName'
      ]),
      logoUrl() {
        return require('../../assets/pfx-logo-white.png')
      },
      profileLinkLabel() {
        return this.fullName !== '' ? this.fullName : 'Profile'
      }
    },
    methods: {
      logout() {
        this.$store.dispatch('logout')
        if (this.$route.meta.authRequired) {
          this.$router.push('/')
        } else {
          this.$router.go() // refresh current route
        }
      },
      forcedRefresh(value) {
        let page = window.location.href.replace('https://', '').split('/')[1]
        if(page == value) {
          this.$router.go()
        }else{
          this.$router.push('/' + value)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../pfx.scss';

  #logo {
    float: left;
    img {
      margin-top: 0.25rem;
      height: 1.1rem;
    }
  }

  nav {
    float: right;
    white-space: nowrap;

    text-align: right;
    li {
      cursor: pointer;
      display: inline;
      margin: 0 .5rem;
      a {
        text-decoration: none;
        color: $color-header-fg;
      }
    }
    li:first-child { margin-left: 0; }
    li:last-child { margin-right: 0; }
    li {
      a:hover {
        text-decoration: underline;
      }
    }
    li.blue-pill {
      background-color: $color-pfx-brand;
      border-radius: 8px;
      padding: 6px 12px;
    }
  }

  .popup-menu {
    position: absolute;
    top: $header-bar-height - 1rem;
    right: 1rem;
    z-index: 2;
    background: $color-header-bg;
    box-shadow: $header-shadow;
    color: $color-header-fg;
    ul {
      li {
        display: block;
        padding: .5rem 1rem;
        margin: 0;
        a {
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }

  .user-avatar {
    height: 1.5rem;
    vertical-align: middle;
    margin-right: 4px;
  }

  @media screen and (max-width: $tablet-portrait-min-width) {
    .wide-show {
      display: none !important;
    }
  }
  @media screen and (min-width: $tablet-portrait-min-width) {
    .wide-hide {
      display: none !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/elements/MainHeaderContent.vue